import { AxiosRequestConfig } from 'axios';

import Client from './client';

type Data = {
  device: string;
  deviceId: string;
  os: string;
  osVersion: string;
  password: string;
  preToken: string;
  token: string;
};

type Response = {
  readonly result: 'SUCCESS' | 'FAIL';
  readonly status: number;
  readonly message: string;
  readonly userId: string;
  readonly refreshToken: string;
  readonly hasPhoneNumber: boolean;
  readonly setupComplete: boolean;
  readonly region: string;
  readonly admin: boolean;
};

export default (data: Data, config?: AxiosRequestConfig) => {
  return Client.post<Response>('/auth/v1/recover/do', data, config);
};
